// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.PartnerPrivacyPolicy-riderBlog-lEuKT {
  margin-bottom: 80px;
}`, "",{"version":3,"sources":["webpack://./src/routes/static/partnerPrivacyPolicy/PartnerPrivacyPolicy.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;AACrB","sourcesContent":[".riderBlog {\n  margin-bottom: 80px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"riderBlog": `PartnerPrivacyPolicy-riderBlog-lEuKT`
};
module.exports = ___CSS_LOADER_EXPORT___;
